import React, { createContext, useContext, useState, useMemo } from 'react'

export const FormDataContext = createContext()

export const useFormData = () => useContext(FormDataContext)

const FormDataProvider = ({ children }) => {

  const [form, setForm] = useState({
    description: '',
    fields: [],
    form_id: 1,
    mandatory: false,
    remember_description: null,
  })
  const value = useMemo(() => ({
    form: form,
    setFormData: setForm,
  }), [form])

  return (
    <FormDataContext.Provider value={value} changeDataForm={setForm}>
      {children}
    </FormDataContext.Provider>

  )
}

export const withFormData = component => props =>
  React.createElement(component, { ...props, form: useFormData() })

export default FormDataProvider
